<template>
  <div id="app">
    <!-- <HomeView/> -->
    <router-view/>
    <!-- 底部信息栏 -->
    <div class="b-wave" style="background-color: #f5f5f5;"></div>
    <FooterComponent :SpgData="SpgData"/>
    <ContactMobile  :SpgData="SpgData"/>
    <gotoTop/>
  </div>
</template>
<script>
// import { RouterView } from 'vue-router';
// import HomeView from './components/HomeView.vue'

export default {
  name: 'App',
  data() {
    return {
      SpgData:{}
    }
  },
  components: {
    // HomeView
  },
  created() {
    this.getSpgWebAllData()
  },
  methods: {
    async getSpgWebAllData() {
      try {
        const SpgData = await this.$db.collection('SPG-WEB-SpgData').get()
        this.SpgData = SpgData.data[0]
        this.$nextTick(() => {
          this.$wow.sync() // 同步新添加的元素
        })
        // console.log(this.ProductData)
      } catch (err) {
        console.error('数据请求失败：', err)
        // this.$message?.error('数据请求失败') 
      }
    }
  }
}
</script>

<style>
html,body{margin: 0 auto;padding: 0;font-size: 30px;overflow-x: hidden;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
